import React, { useEffect, useState, useRef } from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import {
  DATETIME_DEFAULT_SHORT_FORMAT,
  StatusImovel,
} from '~/constant';
import ModalReserva from './ModalReserva';
import { MdCancel, MdRefresh, MdZoomIn, MdZoomOut, MdMap } from 'react-icons/md';
import { formatarMonetario, format } from '~/Utils/Helpers';
import { Col, Row } from 'react-bootstrap';
import AuthStorage from '~/Utils/AuthStorage';

const MapaInterativo = ({
  ativos,
  atualizarMapa,
  atualizarReservados,
  ativosFiltrados,
  setAtivosFiltrados,
  quadraFiltrada,
  setQuadraFiltrada,
  loteFiltrado,
  setLoteFiltrado,
  codigoFamilia,
  nomeEmpreendimento,
  onTrocarMapa,
  svgData,
  prospectoInicial,
}) => {
  const [zoomQuadra, setZoomQuadra] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [codigoAtivo, setCodigoAtivo] = useState(null);
  const [tooltipInfo, setTooltipInfo] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [ativoSelecionado, setAtivoSelecionado] = useState(null);
  const ativosSegundaFase = [
    47658, 47659, 47660, 47661, 47662, 47663, 47664, 47665, 47666, 47667,
    47687, 47688, 47689, 47690, 47691, 47692, 47693, 47694, 47695, 47696,
    47697, 47698, 47699, 47700, 47701, 47702, 47703, 47704, 47705, 47706,
    47707, 47708, 47709, 47778, 47779, 47780, 47781, 47782, 47783, 47784,
    47785, 47786, 47787, 47788, 47789, 47790, 47791, 47792, 47793, 47794,
    47795, 47796, 47797, 47798, 47799, 47800, 47801, 47802, 47803, 47804,
    47805, 47806, 47807, 47808, 47809, 47810, 47811, 47812, 47813, 47814,
    47815, 47816, 47817, 47818, 47819, 47820, 47821, 47822, 47823, 47824,
    47825, 47826, 47827, 47828, 47829, 47830, 47831, 47832, 47833, 47834,
    47835, 47836, 47837, 47838, 47839, 47840, 47841, 47842, 47843, 47844,
    47845, 47846, 47847, 47973, 47974, 47975, 47976, 47977, 47978, 47979,
    47980, 47981, 47982, 47983, 47984, 47985, 47986, 47987, 47988, 47989,
    47990, 47991, 47992, 47993, 47994, 47995, 47996, 47997, 47998, 47999,
    48000, 48001, 48002, 48003, 48004, 48005, 48006, 48007, 48008, 48009,
    48010, 48011, 48012, 48013, 48014, 48015, 48016, 48017, 48018, 48019,
    48020, 48021, 48022,
  ];

  const temCaracteristica = AuthStorage.temCaracteristica(453);
  const zoomToElementRef = useRef(null);
  const resetTransformRef = useRef(null);
  const clickTimerRef = useRef(null);
  const zoomQuadraRef = useRef(null);

  const zoomQuadraFiltrada = idAtivo => {
    if (zoomToElementRef.current && idAtivo) {
      const quadra = document.getElementById(idAtivo);
      if (quadra && quadra.parentElement.id) {
        zoomToElementRef.current(quadra.parentElement.id);
      }
    }
  };

  const zoomLoteFiltrado = idAtivo => {
    if (zoomToElementRef.current && idAtivo) {
      const lote = document.getElementById(idAtivo);
      if (lote) {
        zoomToElementRef.current(lote);
      }
    }
  };

  const handleReset = resetTransform => {
    resetTransform();
    atualizarMapa();
    setZoomQuadra(null);
  };

  const transformarLoteEmCasa = loteElement => {
    if (!loteElement || loteElement.dataset.casaAplicada === 'true') {
      return loteElement;
    }

    let bbox;
    try {
      bbox = loteElement.getBBox();
    } catch (e) {
      return loteElement;
    }

    const { x, y, width: w, height: h } = bbox;
    if (!w || !h) return loteElement;

    const alturaTelhado = h * 0.35;
    const points = [
      `${x + w / 2},${y}`,
      `${x + w},${y + alturaTelhado}`,
      `${x + w},${y + h}`,
      `${x},${y + h}`,
      `${x},${y + alturaTelhado}`,
    ].join(' ');

    const ns = 'http://www.w3.org/2000/svg';
    const casa = document.createElementNS(ns, 'polygon');
    casa.setAttribute('points', points);
    casa.setAttribute('id', loteElement.id);

    const classesOriginais = loteElement.getAttribute('class');
    if (classesOriginais) casa.setAttribute('class', classesOriginais);

    ['fill', 'stroke', 'stroke-width', 'style'].forEach(attr => {
      const valor = loteElement.getAttribute(attr);
      if (valor) casa.setAttribute(attr, valor);
    });

    casa.dataset.casaAplicada = 'true';

    loteElement.parentNode.replaceChild(casa, loteElement);
    return casa;
  };

  const abrirModalLote = imovel => {
    setCodigoAtivo(imovel.codigo);
    setMostrarModal(true);
    setAtivosFiltrados([]);
    setAtivoSelecionado(imovel);

    if (resetTransformRef.current) {
      handleReset(resetTransformRef.current);
    }
  };

  useEffect(() => {
    if (quadraFiltrada) {
      zoomQuadraFiltrada(quadraFiltrada);
      setQuadraFiltrada(null);
    }
    if (loteFiltrado) {
      zoomLoteFiltrado(loteFiltrado);
      setLoteFiltrado(null);
    }

    ativos.forEach(imovel => {
      let loteElement = document.getElementById(imovel.codigo);
      if (loteElement) {
        if (imovel.tem_casa) {
          loteElement = transformarLoteEmCasa(loteElement);
        }
        loteElement.classList.remove(
          'disponivelF1',
          'vendido',
          'reservado',
          'bloqueado',
          'destacar-ativos-filtro'
        );

        if (
          imovel.status === StatusImovel.Vendido ||
          imovel.status === StatusImovel.PreVenda
        )
          if (ativosSegundaFase.includes(imovel.codigo)) {
            loteElement.classList.add('vendido-segunda-fase');
          } else {
            loteElement.classList.add('vendido');
          }
        else if (imovel.status === StatusImovel.Reservado)
          if (ativosSegundaFase.includes(imovel.codigo)) {
            loteElement.classList.add(
              imovel.rodada_negocio
                ? 'rodada-negocio'
                : 'reservado-segunda-fase'
            );
          } else {
            loteElement.classList.add(
              imovel.rodada_negocio ? 'rodada-negocio' : 'reservado'
            );
          }
        else if (imovel.status === StatusImovel.Bloqueado)
          loteElement.classList.add('bloqueado');
        else if (imovel.status === StatusImovel.Disponivel) {
          if (ativosSegundaFase.includes(imovel.codigo)) {
            loteElement.classList.add('ativo-segunda-fase');
          } else {
            loteElement.classList.add('disponivelF1');
          }
        }
        if (
          ativosFiltrados.some(filtrado => filtrado.codigo === imovel.codigo)
        ) {
          loteElement.classList.add('destacar-ativos-filtro');
        }
      }
    });
  }, [ativos, ativosFiltrados, svgData]);

  useEffect(() => {
    zoomQuadraRef.current = zoomQuadra;
  }, [zoomQuadra]);

  useEffect(() => {
    if (!svgData) return;

    const handlers = [];

    ativos.forEach(imovel => {
      const loteElement = document.getElementById(imovel.codigo);
      if (!loteElement) return;

      const onMouseEnter = event => showTooltip(event, imovel);

      const onClick = event => {
        event.stopPropagation();

        if (clickTimerRef.current) {
          clearTimeout(clickTimerRef.current);
          clickTimerRef.current = null;
          abrirModalLote(imovel);
        } else {
          clickTimerRef.current = setTimeout(() => {
            clickTimerRef.current = null;

            if (zoomQuadraRef.current) {
              abrirModalLote(imovel);
            } else {
              const quadraElement = loteElement.parentElement;
              if (
                quadraElement &&
                quadraElement.id &&
                zoomToElementRef.current
              ) {
                zoomToElementRef.current(quadraElement);
                setZoomQuadra(quadraElement.id);
              }
            }
          }, 300);
        }
      };

      loteElement.addEventListener('mouseenter', onMouseEnter);
      loteElement.addEventListener('mouseleave', hideTooltip);
      loteElement.addEventListener('click', onClick);

      handlers.push({
        element: loteElement,
        onMouseEnter,
        onClick,
      });
    });

    return () => {
      handlers.forEach(({ element, onMouseEnter, onClick }) => {
        element.removeEventListener('mouseenter', onMouseEnter);
        element.removeEventListener('mouseleave', hideTooltip);
        element.removeEventListener('click', onClick);
      });
      if (clickTimerRef.current) {
        clearTimeout(clickTimerRef.current);
        clickTimerRef.current = null;
      }
    };
  }, [ativos, svgData]);

  const showTooltip = (event, imovel) => {
    setTooltipInfo(imovel);
    setTooltipPosition({ x: event.pageX, y: event.pageY });
  };

  const hideTooltip = () => {
    setTooltipInfo(null);
  };

  const obterStatusDoAtivo = (status, familia, rodada_negocio) => {
    const statusStyles = {
      [StatusImovel.Disponivel]: {
        text: 'Disponível',
        style: {
          borderRadius: '8px',
          padding: '1px 6px',
          background: '#fecc66',
          color: 'black',
        },
      },
      [StatusImovel.Bloqueado]: {
        text: 'Bloqueado',
        style: {
          borderRadius: '8px',
          padding: '1px 6px',
          background: 'black',
          color: '#fff',
        },
      },
      [StatusImovel.Vendido]: {
        text: 'Vendido',
        style: {
          borderRadius: '8px',
          padding: '1px 6px',
          background: '#ee7272d1',
          color: 'black',
        },
      },
      [StatusImovel.PreVenda]: {
        text: 'Vendido',
        style: {
          borderRadius: '8px',
          padding: '1px 6px',
          background: '#ee7272d1',
          color: 'black',
        },
      },
      [StatusImovel.PropostaRapida]: {
        text: 'Vendido',
        style: {
          borderRadius: '8px',
          padding: '1px 6px',
          background: '#ee7272d1',
          color: 'black',
        },
      },
      [StatusImovel.Reservado]: {
        text: rodada_negocio ? 'Em negociação PDF' : 'Em negociação',
        style: {
          borderRadius: '8px',
          padding: '1px 6px',
          background: rodada_negocio ? '#2088f8' : '#9dcbfb',
          color: 'black',
        },
      },
    };

    const currentStatus = statusStyles[status];

    if (currentStatus) {
      return (
        <>
          Situação:{' '}
          <strong style={currentStatus.style}>{currentStatus.text}</strong>
        </>
      );
    }
    return null;
  };

  return (
    <div className="" style={{ position: 'relative' }}>
      <TransformWrapper limitToBounds={false}>
        {({ zoomIn, zoomOut, zoomToElement, resetTransform }) => {
          zoomToElementRef.current = zoomToElement;
          resetTransformRef.current = resetTransform;
          return (
            <div className="w-100 h-100">
              <div className="grupo-botoes-acoes-mapa">
                <button
                  className="btn btn-secondary btn-acao-mapa"
                  onClick={() => handleReset(resetTransform)}
                >
                  <MdCancel />
                </button>
                <button
                  className="btn btn-secondary btn-acao-mapa"
                  onClick={() => zoomIn()}
                >
                  <MdZoomIn />
                </button>
                <button
                  className="btn btn-secondary btn-acao-mapa"
                  onClick={() => {
                    atualizarMapa();
                    zoomOut();
                  }}
                >
                  <MdZoomOut />
                </button>
                <button
                  className="btn btn-success btn-acao-mapa"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  <MdRefresh />
                </button>
                {onTrocarMapa && (
                  <button
                    className="btn btn-info btn-acao-mapa"
                    onClick={onTrocarMapa}
                    title="Trocar mapa"
                  >
                    <MdMap />
                  </button>
                )}
              </div>
              <TransformComponent>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox={svgData.viewBox}
                  className="mapa-svg"
                  style={{ background: '#353535' }}
                  dangerouslySetInnerHTML={{ __html: svgData.innerHTML }}
                />

                {ativoSelecionado && (
                  <ModalReserva
                    mostrarModal={mostrarModal}
                    setMostrarModal={setMostrarModal}
                    codigoAtivo={codigoAtivo}
                    ativo={ativoSelecionado}
                    atualizarReservados={atualizarReservados}
                    atualizarMapa={atualizarMapa}
                    prospectoInicial={prospectoInicial}
                  />
                )}
              </TransformComponent>
            </div>
          );
        }}
      </TransformWrapper>

      {tooltipInfo && (
        <div
          style={{
            position: 'absolute',
            top: tooltipPosition.y - 50,
            left: tooltipPosition.x - 50,
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderRadius: '8px',
            pointerEvents: 'none',
            zIndex: 1000,
            width: '430px',
            padding: '10px',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
          }}
        >
          <h6 className="text-center mb-2">Informações do terreno</h6>
          <Row>
            <Col md="6">
              <small
                style={{
                  borderRadius: '8px',
                  padding: '2px 6px',
                  background: '#fecc66',
                  color: 'black',
                  display: 'inline-block',
                }}
              >
                <strong>{tooltipInfo.nome_familia}</strong>
              </small>
            </Col>
            <Col md="6">
              <small>
                Quadra: <strong>{tooltipInfo.quadra}</strong> / Lote:{' '}
                <strong>{tooltipInfo.lote}</strong>
              </small>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <small>
                {obterStatusDoAtivo(
                  tooltipInfo.status,
                  tooltipInfo.codigo_familia,
                  tooltipInfo.rodada_negocio
                )}
              </small>
            </Col>
            <Col md="6">
              <small>
                Entrada:{' '}
                <strong>{formatarMonetario(tooltipInfo.valor_sinal)}</strong>
              </small>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <small>
                Área: <strong>{tooltipInfo.area}m²</strong>
              </small>
            </Col>
            <Col md="6">
              {tooltipInfo.valor_inicial_parcela_programada > 0 && (
                <small>
                  Programadas:{' '}
                  <strong>
                    {formatarMonetario(
                      tooltipInfo.valor_inicial_parcela_programada
                    )}
                  </strong>
                </small>
              )}
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <small>
                Valor à vista:{' '}
                <strong>{formatarMonetario(tooltipInfo.valor_vista)}</strong>
              </small>
            </Col>
            <Col md="6">
              <small>
                Financ.:{' '}
                <strong>
                  {tooltipInfo.parcelas} x{' '}
                  {formatarMonetario(tooltipInfo.valor_parcela)}
                </strong>
              </small>
            </Col>
          </Row>
          {tooltipInfo.solicitacao_estorno > 0 && (
            <Row>
              <Col md="12 text-center">
                <div className="badge badge-warning w-100">
                  Aguardando estorno de proposta.
                </div>
              </Col>
            </Row>
          )}
          {tooltipInfo.observacao_reserva && temCaracteristica && (
            <Row>
              <Col md="6">
                <div className="badge badge-dark" style={{ color: 'white' }}>
                  Observação: {tooltipInfo.observacao_reserva}
                </div>
              </Col>
            </Row>
          )}

          {tooltipInfo.status !== StatusImovel.Bloqueado &&
            tooltipInfo.status !== StatusImovel.Disponivel && (
              <>
                <hr className="mb-2" />
                <h6 className="text-center mb-2">Informações da reserva</h6>
                {tooltipInfo.mesa && (
                  <Row className="mt-2">
                    <Col>
                      <small>
                        Mesa:{' '}
                        <strong>
                          {tooltipInfo.mesa} - {tooltipInfo.nome_usuario_mesa}
                        </strong>
                      </small>
                    </Col>
                  </Row>
                )}
                {tooltipInfo.nome_corretor && (
                  <Row>
                    <Col>
                      <small>
                        Corretor:{' '}
                        <strong>
                          {tooltipInfo.codigo_corretor} -{' '}
                          {tooltipInfo.nome_corretor}
                        </strong>
                      </small>
                    </Col>
                  </Row>
                )}
                {tooltipInfo.nome_cliente && (
                  <Row>
                    <Col>
                      <small>
                        Nome:{' '}
                        <strong>
                          {tooltipInfo.codigo_prospecto} -{' '}
                          {tooltipInfo.nome_cliente}
                        </strong>
                      </small>
                    </Col>
                  </Row>
                )}
                {tooltipInfo.data_validade && (
                  <Row>
                    <Col md="6">
                      <small>
                        Reserva:{' '}
                        <strong>
                          {format.date(
                            tooltipInfo.data_reserva,
                            DATETIME_DEFAULT_SHORT_FORMAT
                          )}
                        </strong>
                      </small>
                    </Col>
                    <Col md="6">
                      <small>
                        Validade:{' '}
                        <strong>
                          {format.date(
                            tooltipInfo.data_validade,
                            DATETIME_DEFAULT_SHORT_FORMAT
                          )}
                        </strong>
                      </small>
                    </Col>
                  </Row>
                )}
              </>
            )}
          {tooltipInfo.status === StatusImovel.Bloqueado && (
            <>
              <hr className="mb-2" />
              <h6 className="text-center mb-2">Lote Bloqueado</h6>
              {tooltipInfo.log_bloqueio && (
                <Row className="mt-2">
                  <Col>
                    <small>
                      log:{' '}
                      <strong>
                        {format.date(
                          tooltipInfo.log_bloqueio.data_hora,
                          DATETIME_DEFAULT_SHORT_FORMAT
                        )}
                      </strong>
                    </small>
                  </Col>
                </Row>
              )}
              {tooltipInfo.log_bloqueio.atualizacao && (
                <Row className="mt-2">
                  <Col>
                    <small>
                      Bloq.:{' '}
                      <strong>{tooltipInfo.log_bloqueio.atualizacao}</strong>
                    </small>
                  </Col>
                </Row>
              )}
              {tooltipInfo.log_bloqueio.nome_usuario && (
                <Row className="mt-2">
                  <Col>
                    <small>
                      Usuário:{' '}
                      <strong>{tooltipInfo.log_bloqueio.nome_usuario}</strong>
                    </small>
                  </Col>
                </Row>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default MapaInterativo;
